import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" お客様から投稿いただいた廃車お客様の声を一部ご紹介。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 廃車をお考えの方はご参考ください。 ")
], -1)
const _hoisted_2 = { class: "relative-position" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_review_list = _resolveComponent("review-list")!
  const _component_q_pagination = _resolveComponent("q-pagination")!
  const _component_q_inner_loading = _resolveComponent("q-inner-loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_review_list, {
        data: _ctx.reviewList,
        class: "q-my-md"
      }, null, 8, ["data"]),
      _createVNode(_component_q_pagination, {
        unelevated: "",
        "model-value": _ctx.pagination.page,
        max: Math.ceil(_ctx.pagination.rowsNumber / _ctx.pagination.rowsPerPage),
        color: "primary",
        "direction-links": "",
        "boundary-links": "",
        "icon-first": "first_page",
        "icon-last": "last_page",
        "icon-prev": "chevron_left",
        "icon-next": "chevron_right",
        "onUpdate:modelValue": _ctx.updatePagination,
        class: "justify-center"
      }, null, 8, ["model-value", "max", "onUpdate:modelValue"]),
      _createVNode(_component_q_inner_loading, {
        showing: _ctx.getReviewTask.isRunning
      }, null, 8, ["showing"])
    ])
  ], 64))
}